import React, { useState } from 'react';
import { EntitySettings } from 'screens/Admin/components';

const Settings = ({ update, isLive, closeModal, visible, setVisible }) => {
  const [loading, setLoading] = useState(false);

  if (!update) return null;

  const settings = [
    {
      text: 'Remove event',
      icon: 'delete',
      onClick: () => setVisible('remove')
    }
  ];

  if (isLive && update?.type === 'game') {
    settings.unshift({
      text: 'Conclude game',
      icon: 'check',
      onClick: () => setVisible('conclude')
    });
  }

  return (
    <React.Fragment>
      <EntitySettings options={settings} />
    </React.Fragment>
  );
};

// <Col noFlex center>
//   <Clickable onClick={handleRemoveModal}>
//     <Text col={theme.SECONDARY} med>
//       Remove event
//     </Text>
//   </Clickable>
//
//   {isLive && storedData.type === 'game' && (
//     <Clickable onClick={handleConcludeModal}>
//       <Text med>
//         Conclude Game
//       </Text>
//     </Clickable>
//   )}
// </Col>

export default Settings;
